var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"mfp-popup-video",attrs:{"id":"heroVideoPopup","autoplay":"","controls":"","controlslist":"nodownload","src":_vm.videoSrc,"type":"video/mp4"}})}
var staticRenderFns = []

export { render, staticRenderFns }